/* eslint-disable @typescript-eslint/naming-convention */
import React from "react";
import {
  Box,
  Typography,
  Button,
  Avatar,
  CircularProgress,
} from "@mui/material";
import clsx from "clsx";
import { Add } from "@mui/icons-material";
import useStyle from "./Styles";

type userProfile = {
  id: string;
  name: string;
  email: string;
  picture: {
    data: {
      url: string;
    };
  };
};

interface IConnectedBox {
  user: userProfile;
  logout: () => void;
  handleAddMorePages: () => void;
  loading: boolean;
  isCollapsed: boolean;
}

const ConnectedBox: React.FC<IConnectedBox> = ({
  user,
  logout,
  handleAddMorePages,
  loading,
  isCollapsed,
}) => {
  const { classes } = useStyle();

  return (
    <Box className={clsx(classes.rootConnectedBox, isCollapsed && "collapsed")}>
      <Avatar
        src={user?.picture?.data?.url}
        alt={user?.name}
        className={clsx(classes.avatar, isCollapsed && "collapsed")}
      />

      <Typography
        variant="h6"
        className={clsx(classes.userName, isCollapsed && "collapsed")}
      >
        {user?.name}
      </Typography>

      <Box className={classes.actionGroup}>
        <Button
          className={classes.DisconnectButton}
          variant="outlined"
          onClick={logout}
          disabled={loading}
        >
          Disconnect
        </Button>

        <Button
          className={classes.labelAddButton}
          variant="contained"
          onClick={handleAddMorePages}
          disabled={loading}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            {loading ? (
              <CircularProgress
                size={18}
                className={classes.circularProgress}
              />
            ) : (
              <Add className={classes.labelAddIcon} />
            )}
            Add WhatsApp
          </Box>
        </Button>
      </Box>
    </Box>
  );
};

export default ConnectedBox;
